import React from 'react';
import { ScheduleEvent, BookModel } from '../../../../../models';
import { BookOpen, Building2, Layers, Files, GraduationCap, Calendar, Video, ListOrdered } from 'lucide-react';

interface ScheduleBookInfoProps {
    event: ScheduleEvent;
    book: BookModel | null;
}

const ScheduleBookInfo: React.FC<ScheduleBookInfoProps> = ({ event, book }) => {

    const getSubjectColor = (subject: string) => {
        const colors: Record<string, string> = {
            '국어': 'bg-rose-500', '수학': 'bg-blue-600', '영어': 'bg-indigo-600',
            '한국사': 'bg-amber-700', '사회': 'bg-orange-600', '과학': 'bg-emerald-600',
        };
        return colors[subject] || 'bg-slate-600';
    };

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="flex flex-col items-center sm:items-start text-center sm:text-left">
                <div className="w-32 h-44 sm:w-40 sm:h-56 bg-slate-50 rounded-2xl shadow-lg border border-slate-100 flex items-center justify-center overflow-hidden mb-4 relative">
                    {book?.coverUrl ? (
                        <img src={book.coverUrl} className="w-full h-full object-cover p-1.5" alt={book.title} />
                    ) : (
                        <div className={`w-full h-full flex flex-col items-center justify-center text-white ${getSubjectColor(event.subject)}`}>
                            <BookOpen size={40} className="opacity-30 mb-2" />
                            <span className="font-black text-lg">{event.subject}</span>
                        </div>
                    )}
                </div>
                <div className="space-y-3 w-full">
                    <div className="flex items-center gap-2 text-slate-400 font-bold justify-center sm:justify-start">
                        <Building2 size={14} />
                        <span className="text-[10px] sm:text-xs">{book?.publisher}</span>
                        <span className="opacity-20">•</span>
                        <span className="text-[10px] sm:text-xs">{book?.grade}</span>
                    </div>
                </div>
            </div>

            <div className="space-y-5">
                <section>
                    <h4 className="text-[9px] font-black text-slate-400 uppercase tracking-widest mb-2">학습 현황</h4>
                    <div className="bg-slate-50 rounded-xl p-4 border border-slate-100">
                        <div className="flex items-center justify-between mb-2">
                            <span className="text-xs font-bold text-slate-600">현재 일정 진행도</span>
                            <span className="text-sm font-black text-indigo-600">{event.status === 'completed' ? '100%' : '0%'}</span>
                        </div>
                        <div className="w-full h-1.5 bg-white rounded-full overflow-hidden border border-slate-100 shadow-inner">
                            <div
                                className={`h-full transition-all duration-1000 ${event.status === 'completed' ? 'bg-emerald-500 w-full' : 'bg-indigo-500 w-0'}`}
                            />
                        </div>
                        <p className="mt-2 text-[10px] font-medium text-slate-400 leading-relaxed">
                            이 교재의 '{event.task}' 단계를 마무리하하셨나요? 상단의 완료 버튼을 눌러 기록해 주세요.
                        </p>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default ScheduleBookInfo;
